import {
  IcoaTransactions,
  ICOA,
  ISupplierUserProfile,
  IUser,
} from 'constants/interfaces';
import React, {useCallback, useEffect, useState} from 'react';
import {apiGetUser, apiUploadFile} from 'constants/Api';
import {
  Typography,
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  TextField,
  Button,
  Tooltip,
} from '@material-ui/core';
import {formatDate} from 'constants/index';
import {Breakpoint} from '@material-ui/core/styles/createBreakpoints';
import axios from 'axios';

export function CustomerFinancials(props: {
  user: ISupplierUserProfile;
  customerUserId: string;
  width: Breakpoint;
}) {
  enum docStates {
    UPLOADING,
    ANALYSING,
    DONE,
  }
  const {user, customerUserId} = props;

  const [tabIndex] = useState(0);
  const showTabs = props.width === 'xs' || props.width === 'sm';

  const [isLoadingCustomer, setIsLoadingCustomer] = useState<boolean>(false);
  const [customer, setCustomer] = useState<IUser>();
  // eslint-disable-next-line no-unused-vars
  const [accounts, setAccounts] = useState<Array<ICOA>>([]);

  const [filteredAccounts, setFilteredAccounts] = useState<Array<ICOA>>([]);
  const [, setAllAccounts] = useState<Array<ICOA>>([]);
  const [searchedAccounts, setSearchedAccounts] = useState<Array<ICOA>>([]);
  const [selectedAccount, setSelectedAccount] = useState<ICOA | null>(null);
  const [transactions, setTransactions] = useState<Array<IcoaTransactions>>([]);
  const [accountFilter, setAccountFilter] = useState<Array<string>>([]);
  const [accountTypeFilter, setAccountTypeFilter] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [userHasTransactions, setUserHasTransactions] = useState(false);
  const [docStatesUploading, setDocStates] = useState(docStates.UPLOADING);
  const [uploadDoc, setUploadDoc] = useState(false);

  const loadCustomer = useCallback((customerUserId: string) => {
    setIsLoadingCustomer(true);
    apiGetUser(customerUserId)
      .then(setCustomer)
      .catch((error) => {
        alert('Error loading customer. Please try again later');
        console.error(error);
      })
      .then(() => setIsLoadingCustomer(false));
  }, []);

  useEffect(() => {
    loadCustomer(customerUserId);
  }, [customerUserId, loadCustomer]);

  const runGetData = () => {
    axios
      .get(
        `http://khuladev.co.za:4010/transactions/userHasTransactions/${customer?.id}`,
      )
      .then((response) => {
        console.log(response.data);
        if (response.data) {
          setUserHasTransactions(true);
          axios
            .get('http://khuladev.co.za:4010/accounts')
            .then((response) => {
              setAllAccounts(response.data);
              axios
                .get(`http://khuladev.co.za:4010/accounts/user/${customer?.id}`)
                .then((response) => {
                  const data = response.data as Array<ICOA>;
                  setFilteredAccounts(response.data);
                  setAccounts(response.data);
                  setSearchedAccounts(response.data);
                  const array = Array.from(
                    new Set(data.map((a) => a.account_type)),
                  ).sort();
                  array.unshift('All');
                  setAccountFilter(array);
                })
                .catch((error) =>
                  console.error('Error fetching user accounts:', error),
                );
            })
            .catch((error) => console.error('Error fetching accounts:', error));
        } else {
          console.log('we need to upload a pdf');
        }
      });
  };
  useEffect(() => {
    console.log(isLoadingCustomer);

    if (!isLoadingCustomer && customer) {
      runGetData();
    }
  }, [isLoadingCustomer]);

  const handleAccountClick = (account: any) => {
    setSelectedAccount(account);
    axios
      .get(
        `http://khuladev.co.za:4010/accounts/transactions/${account._id}/${customer?.id}`,
      )
      .then((response) => {
        setTransactions(response.data);
      })
      .catch((error) => console.error('Error fetching transactions:', error));
  };
  const handleAccountTypeFilter = (type: string) => {
    setAccountTypeFilter(type);

    if (type === 'All') {
      setFilteredAccounts(accounts);
    } else {
      const filtered = accounts.filter((a) => a.account_type === type);
      setFilteredAccounts(filtered);
    }
  };

  useEffect(() => {
    const searched =
      searchQuery.trim() == ''
        ? filteredAccounts
        : filteredAccounts.filter((a) =>
            a.account_name.toLowerCase().includes(searchQuery.toLowerCase()),
          );
    setSearchedAccounts(searched);
  }, [searchQuery, filteredAccounts]);

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (event.target.files) {
      setUploadDoc(true);

      const file = event.target.files[0];
      const fileKey = `${new Date().getTime()}_${user.userId}_customer_pdf.pdf`;
      try {
        const fileUrl = await apiUploadFile(file, fileKey);
        const fileUrEncode = encodeURIComponent(fileUrl);

        setDocStates(docStates.ANALYSING);
        axios
          .get(
            `http://khuladev.co.za:4010/transactions/openai?customerId=${customer?.id}&file=${fileUrEncode}`,
          )
          .then((response) => {
            setDocStates(docStates.DONE);

            setUploadDoc(false);
            runGetData();
          })
          .catch((error) => {
            console.log('Error uploading file:', error);
          });
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }
  };

  return (
    <div className="order-detail">
      {uploadDoc ? (
        <Paper className="upload-container" variant="outlined">
          {docStatesUploading === docStates.UPLOADING ? (
            <Typography>Uploading...</Typography>
          ) : docStatesUploading === docStates.ANALYSING ? (
            <Typography>Analysing...</Typography>
          ) : (
            <Typography>Done</Typography>
          )}
        </Paper>
      ) : isLoadingCustomer ? (
        <Typography>Loading...</Typography>
      ) : !userHasTransactions ? (
        <Paper className="upload-container" variant="outlined">
          <Typography variant="h6" style={{marginBottom: '20px'}}>
            No Transactions Found
          </Typography>
          <input
            accept="application/pdf"
            style={{display: 'none'}}
            id="upload-pdf"
            type="file"
            onChange={handleFileUpload}
          />
          <label htmlFor="upload-pdf">
            <Button variant="contained" color="primary" component="span">
              Upload PDF
            </Button>
          </label>
        </Paper>
      ) : (
        <Grid container className="container">
          <Grid
            item
            xs={12}
            md={3}
            className="grid-column"
            style={{display: showTabs && tabIndex === 0 ? 'none' : ''}}
          >
            <Paper className="order-info-container" variant="outlined">
              <Box className="farm-details-container">
                <Box className="header-container">
                  <Typography variant="subtitle1">Chart of Accounts</Typography>
                  <Select
                    value={accountTypeFilter}
                    onChange={(e) =>
                      handleAccountTypeFilter(e.target.value as string)
                    }
                  >
                    {accountFilter.map((type, index) => (
                      <MenuItem key={index.toString()} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                  <TextField
                    label="Search Accounts"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value as string)}
                    style={{marginTop: 10}}
                  />
                </Box>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Account Type</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {searchedAccounts.map((account) => (
                        <Tooltip
                          key={account._id}
                          title={account.description}
                          arrow
                        >
                          <TableRow
                            onClick={() => handleAccountClick(account)}
                            style={{
                              cursor: 'pointer',
                              backgroundColor:
                                selectedAccount?._id === account._id
                                  ? 'lightgreen'
                                  : 'transparent',
                              color:
                                selectedAccount?._id === account._id
                                  ? 'white'
                                  : 'black',
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                'lightgreen')
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                selectedAccount?._id === account._id
                                  ? 'lightgreen'
                                  : 'transparent')
                            }
                          >
                            <TableCell>{account.account_name}</TableCell>
                            <TableCell>{account.account_type}</TableCell>
                          </TableRow>
                        </Tooltip>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={9} className="grid-column">
            <Paper className="order-info-container" variant="outlined">
              <Box className="header-container">
                <Typography variant="subtitle1">
                  Transactions for {selectedAccount?.account_name}
                </Typography>
              </Box>
              {selectedAccount ? (
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Amount</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {transactions.map((transaction, index) => (
                        <TableRow key={index}>
                          <TableCell>{formatDate(transaction.date)}</TableCell>
                          <TableCell>{transaction.description}</TableCell>
                          <TableCell>{transaction.amount}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography>Select an account to view transactions</Typography>
              )}
            </Paper>
          </Grid>
        </Grid>
      )}
    </div>
  );
}
